module.exports = __webpack_public_path__ + "static/Footer-e4e9dfb100be3cbbb3520fadd050682b.png";